export const Monolith = {
	MFA: {
		CONTEXT_LOGIN: 'login',
		CONTEXT_CHANGE_PASSWORD: 'changePassword',
		CONTEXT_RESET_PASSWORD: 'resetPassword',
		CONTEXT_CHANGE_EMAIL: 'changeEmail',
		CONTEXT_CHANGE_VERIFICATION_MOBILE: 'changeVerificationMobile',
		CONTEXT_VERIFY_NEW_MOBILE: 'verifyNewMobile',
		CONTEXT_ENABLE_MFA: 'enableMFA',
		CONTEXT_DISABLE_MFA: 'disableMFA',
		CONTEXT_FIRST_LOGIN: 'firstLogin',
		CONTEXT_ADMIN_DISABLE_USERS_MFA: 'adminDisableUsersMFA',
	},

	SSO: {
		ENABLE_SSO: 'enableSSO',
		DISABLE_SSO: 'disableSSO',
	},

	Login: {
		CONTEXT_SESSION_EXPIRED: 'sessionExpired',
		CONTEXT_LOGIN: 'login',
	},

	PopUp: {
		MFA_GATEWAY: 'MFAGateway',
		MFA_ENTER_DEVICE: 'MFAEnterDevice',
		MFA_VERIFY_DEVICE: 'MFAVerifyDevice',
		MFA_CHANGE_EMAIL: 'changeEmail',
		MFA_CHANGE_MOBILE: 'changeMobile',
		CHANGE_PASSWORD: 'changePassword',
		VERIFY_EMAIL: 'verifyEmail',
	},

	Events: {
		DROPPABLE_STOP: 'droppableStop',
		POP_UP_LOADED: 'popUpLoaded',
	},

	Integrations: {
		EARVEKESKUS: 'earvekeskus',
	},

	AdapterCodes: {
		SAGE: 'sage',
		QUICKBOOKS: 'quickbooks',
	},

	EmailAlias: {
		CUSTOM: 'custom',
		GMAIL: 'gmail',
		EXCHANGE: 'exchangeMail',
	},

	KeyCodes: {
		ENTER: 13,
		LEFT_ARROW: 37,
		UP_ARROW: 38,
		RIGHT_ARROW: 39,
		DOWN_ARROW: 40,
		BACKSPACE: 8,
		DELETE: 46,
		SPACE: 32,
		TAB: 9,
		ESC: 27,
	},

	Days: {
		SUNDAY: 0,
		MONDAY: 1,
		TUESDAY: 2,
		WEDNESDAY: 3,
		THURSDAY: 4,
		FRIDAY: 5,
		SATURDAY: 6,
	},

	COMMENTS_LIMIT: 3,
	REPLIES_LIMIT: 2,
	TEXTAREA_DEFAULT_COLS: 20,
	AJAX_REQUEST_TIMEOUT_FOR_SCROLL_LOADER: 120 * 1000, // two minutes, just like runPartialListQuery in scrollLoader.php
	COMMENTS_REL: 'cr',
	UNSPECIFIED_DURATION: -1,
	MINUTE_SELECT_OTHER: 'other',

	InternationalPhoneInput: {
		DISABLE_VALIDATION: 'js-disable-phone-validation',
	},

	Validation: {
		PHONE_INPUT: 'js-validate-phone-number',
	},

	DatePicker: {
		CUSTOM_PERIOD: 'customPeriod',
	},

	Width: {
		PopUp: {
			ProductListIframe: 1000,
		},
	},

	Module: {
		TASK: 'tasks',
		CALENDAR: 'calendar',
		AVAILABILITY_OVERVIEW: 'availability_overview',
		PROJECT_TEMPLATES: 'projectTemplates',
		PROJECTS: 'projects',
		PROJECT_PHASES: 'projectPhases',
		TASK_SETS: 'task_sets',
		COMPANIES: 'companies',
	},

	NodeEvents: {
		Event: {
			NEW_ADDED: 'newEventAdded',
			CHANGED: 'eventChanged',
			DELETED: 'eventDeleted',
		},
		Task: {
			NEW_ADDED: 'newTaskAdded',
			CHANGED: 'taskChanged',
			SET_DONE: 'taskSetDone',
		},
		Phase: {
			NEW_ADDED: 'newPhaseAdded',
			CHANGED: 'phaseChanged',
			DELETED: 'phaseDeleted',
		},
		TimeEntry: {
			CREATED: 'timeEntryCreated',
			MODIFIED: 'timeEntryModified',
			DELETED: 'timeEntryDeleted',
		},
		TimeTracker: {
			START: 'startTimeTracker',
			PAUSE: 'pauseTimeTracker',
			COMPLETE: 'completeTimeTracker',
			REMOVE: 'removeTimeTracker',
			ADD: 'addTimeTracker',
			UPDATE: 'updateTimeTracker',
		},
		Currencies: {
			GENERATION_FINISHED: 'currenciesGenerationFinished',
		},
		CustomEntry: {
			MODIFIED: 'itemChanged',
			CREATED: 'newItemAdded',
			DELETED: 'itemDeleted',
			SORTING_CHANGED: 'sortOrderChanged',
		},
	},

	EventTypes: {
		CAL: 'cal',
		TASK: 'task',
	},

	Action: {
		VIEW: 'view',
		MODIFY: 'modify',
		CREATE: 'create',
		DELETE: 'delete',
	},

	Gantt: {
		TYPE_PROJECT: 'project',
		TYPE_PHASE: 'phase',
		TYPE_MILESTONE: 'milestone',
		TYPE_TASK: 'task',
		TYPE_EVENT: 'cal',
		TYPE_PLACEHOLDER: 'placeholder',
		TYPE_PHASE_WITHOUT_CHILDREN: 'phase_without_children',
		TYPE_PROJECT_WITHOUT_CHILDREN: 'project_without_children',
		PLACEHOLDER_PHASES: 'phases-add',
		PLACEHOLDER_TASK: 'task-add',
		SETTING_ZOOM_LEVEL_GANTT: 'zoom_level_gantt',
		CHART_SETTINGS_IDENTIFIER: 'ganttChartSettings',
		SETTING_VIEW_OPTION_TIME_ENTRIES: 'filter_view_option_time_entries',
		SETTING_VIEW_OPTION_TASK_PLACEHOLDER:
			'filter_view_option_task_placeholder',
		SETTING_VIEW_OPTION_EVENTS: 'filter_view_option_events',
		SETTING_GANTT_CHART_EXPAND_COLLAPSE: 'gantt_chart_expand',
		SETTING_VIEW_OPTION_PROGRESS: 'filter_view_option_progress',
		SETTING_VIEW_OPTION_ACTUAL_TIMEFRAME:
			'filter_view_option_actual_timeframe',
		SETTING_DEFAULT_TASK_DURATION: 'default_task_duration',
		SETTING_VIEW_OPTION_TITLE: 'filter_view_option_title',
		SETTING_VIEW_OPTION_DURATION: 'filter_view_option_duration',
		SETTING_VIEW_OPTION_ASSIGNEE: 'filter_view_option_assignee',
		SETTING_SIDEBAR_TABLE_WIDTH: 'sidebar_table_width_gantt',
		SETTING_RESCHEDULE_TIME_ENTRIES: 'reschedule_time_entries',
		SETTING_HIDDEN_ZOOM_LEVEL: 'hidden_zoom_level_active',
	},

	AutoSuggest: {
		SKIP_AUTO_SUGGEST_ROW_RENDERING: 'skip-auto-suggest-row-rendering',
	},

	AjaxEvent: {
		FETCH_RELATED_CUSTOMER_PORTAL_USERS: 'fetchRelatedCustomerPortalUsers',
		SAVE_SHOW_CUSTOMER_PORTAL_DASHBOARD_SETTING:
			'saveShowCustomerPortalDashboardSetting',
	},
	Modules: {
		MEDIA_PLAN: 63,
		DEPOT: 153,
	},
	Availability: {
		OVERBOOKED: 100,
		LIGHTLY_OVERBOOKED: 119,
		HEAVY_OVERBOOKED: 139,
	},
	Setting: {
		Bool: {
			USE_ALLOCATION_AS_PLANNED_DURATION:
				'use_allocation_as_planned_duration',
			ROUND_VAT_ON_LINES: 'round_vat_on_lines',
			INCLUDE_WEEKENDS_WHEN_SCHEDULING:
				'include_weekends_when_scheduling',
			ENABLE_MODEL_CHANGE_LOG: 'enableModelChangeLog',
			CREATE_NEW_ENTRIES_IN_SALES_DOCS:
				'create_new_entries_in_sales_docs',
			SHOW_PROJECT_GANTT_BY_DEFAULT: 'show_project_gantt_by_default',
		},
		Num: {
			DEFAULT_EVENT_DURATION: 'default_event_duration',
			DEFAULT_TASK_DURATION: 'default_task_duration',
		},
	},

	AJAX_COMPONENT: {
		QUOTED_VS_ACTUAL:
			'projects/_components/projectQuotedVsActual/projectQuotedVsActual/loadQuotedVsActualTable',
		PROJECT_BUDGETS:
			'projects/_components/projectTabs/projectTabs/loadBudgets',
		LAZY_LOADER: '_components/lazyLoader/lazyLoader/regularAjax',
		TAGS: 'tags', //handled in ajax.php
		CUSTOM_FIELDS: 'customFields', //handled in ajax.php
	},

	LAZY_CONTAINER: {
		BILLS_PURCHASE_ORDERS_EXPENSES:
			'bills-purchase-orders-expenses-container',
		COMMENTS: 'comments-container',
		INVOICES: 'invoices-container',
		ORDERS: 'orders-container',
		PAST_ACTIVITIES: 'past-activities-container',
		PLANNED_ACTIVITIES: 'planned-activities-container',
		PREPAYMENT_INVOICES: 'prepayment-invoices-container',
		QUOTES: 'quotes-container',
		RENTAL_ORDERS: 'rental-orders-container',
		SCHEDULED_BILLS: 'scheduled-bills-container',
		SCHEDULED_INVOICES: 'scheduled-invoices-container',
		DETAILS: 'details-container',
		PROJECT_EVENT_LIST: 'project-event-list-container',
		PROJECT_TASK_BOARD: 'project-task-board-container',
		PROJECT_CALENDAR: 'project-calendar-container',
		PROJECT_FINANCES: 'project-finances-container',
		GANTT_CHART: 'gantt-chart-container',
		SELF_SERVICE_CONTACT_SALES_HUBSPOT_FORM:
			'self-service-contact-sales-hubspot-form-container',
		ACTIVITY_LOCKING: 'activity-locking-container',
	},
};
